export default __webpack_public_path__ + "a0548f5d72425646333dd4788365ff33.png";